import { setUnauthenticatedHandler } from '@/shared/api/unauthenticatedInterceptor';
import { PATHS } from '@/shared/config';
import { redirectToSignIn } from '@/shared/lib';

import { userModel } from '@/entities/user';

import { store } from './store';

export const initSessionEndRedirect = () => {
  setUnauthenticatedHandler(() => {
    // Only a session that ends under a loaded user: before that, the sign-in,
    // invitation and presign flows answer an unauthenticated call themselves.
    // The full page load also drops the signed-out user's data from memory.
    if (
      userModel.selectors.selectCurrentUserID(store.getState()) &&
      !window.location.pathname.endsWith(PATHS.signIn)
    ) {
      redirectToSignIn();
    }
  });
};
